import encrypt from "../../../plugin/lib/encrypt";

export default {
  name: 'Manage',
  data() {
    return {
      username: sessionStorage.getItem('userName'),
      toastMsg: '',
      circleId: '',
      circlename: '',
      circledispl: 'none',
      setdispl: '',
      isDisabled: false,
      toastShow: false,
      toastText: '',
    }
  },
  beforeCreate:function(){
    if(!sessionStorage.getItem('userName')){
      this.$router.replace({name: 'Login'})
    }
  },
  created: function () {
    var data = sessionStorage.getItem('status')
    if (data == 1) {
      this.circledispl = ''
      this.setdispl = 'none'
      this.circlename = sessionStorage.getItem('circleName')
    }
    this.banScale();
  },
  methods: {
    toast (str) {
      let v = this
      v.toastText = str
      v.toastShow = true
      setTimeout(function(){
        v.toastShow = false
      }, 2000)
    },
    banScale(){
      document.addEventListener('touchstart', function (event) {
        if (event.touches.length > 1) {
          event.preventDefault()
        }
      })
      document.addEventListener('gesturestart', function (event) {
        event.preventDefault()
      })//禁止缩放
    },
    onSearch() {
      this.circleId=this.circleId.trim()
      if (!this.circleId)
        this.toastMsg = '请输入公众圈ID'
      else {
        this.isDisabled = true;
        this.$http.get('/circle/v1/operating/circle/check', {params: encrypt({circleId: this.circleId})})
          .then(function (res) {
            if (res.body.msg == "成功") {
              this.circlename = res.body.data.circleName;
              this.circledispl = '';
              this.setdispl = 'none';
              sessionStorage.setItem('status', 1)
              sessionStorage.setItem('circleId', this.circleId)
              sessionStorage.setItem('circleName', this.circlename)
            } else {
              this.toastMsg = res.body.msg;
            }
            this.isDisabled = false;
          })
          .catch(function (res) {
            alert('error')
          })
      }
    },
    toBusiness() {
      this.$router.push({name: 'Business'})
    },
    logOut() {
      sessionStorage.clear();
      this.$router.replace({name: 'Login'})
    },
    toSearch() {
      sessionStorage.removeItem('status');
      sessionStorage.removeItem('circleId');
      sessionStorage.removeItem('circleName');
      this.circledispl = 'none'
      this.setdispl = ''
      this.circleId = ''
    },
    //ios 12+ 微信中白板bug
    checkWxScroll(){
      var ua = navigator.userAgent.toLowerCase();
      var u = navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      if(ua.match(/MicroMessenger/i) == 'micromessenger'&&!!u){
        var osVersion  =  navigator.userAgent.match(/iPhone\sOS\s([\d\_]+)/i);
        var  osArr = osVersion.length>=1? osVersion[1].split('_'):[];
        var newOS = osArr.length>=2 && (osArr[0]>11)
        if(newOS){
          this.temporaryRepair();
        }
      }
    },
    temporaryRepair(){
      var currentPosition,timer;
      var speed=1;
      timer=setInterval(function(){
        currentPosition=document.documentElement.scrollTop || document.body.scrollTop;
        currentPosition-=speed;
        window.scrollTo(0,0);
        clearInterval(timer);
      },1);
    },
    toCreate() {
      const circleId = sessionStorage.getItem('circleId')
      const circleName = sessionStorage.getItem('circleName')
      const userPhone = sessionStorage.getItem('userPhone')
      const userId = sessionStorage.getItem('userId')
      const userName = sessionStorage.getItem('userName')
      var data = {
        circleId: circleId,
        circleName: circleName,
        userPhone: userPhone,
        userId: userId,
        userName: userName
      };
      console.log('data',data);
      this.$router.push({
        name: 'sceneCreate',
        query: {
          circleId: circleId,
          circleName: circleName,
          userPhone: userPhone,
          userId: userId,
          userName: userName
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/page/scene/manage/mg.js